module.exports = __webpack_public_path__ + "static/media/Illustration3-2.f35c9d41.gif";